{
  "#TRANSPORT": {
    "APP": "Energietransport",
    "SHARED": {
      "CANCEL": "Abbrechen",
      "SAVE": "Speichern"
    },
    "DIALOGS": {
      "ASK": {
        "CONFIRM_REMOVE_ITEM": "Möchten Sie diesen Artikel wirklich entfernen?"
      },
      "SIGNATURE": {
        "SAVE": "Speichern",
        "ABORT": "Abbrechen",
        "TITLE": "Unterschrift",
        "MISSING_PERMISSION": "Sie sind nicht Berechtigt den Auftrag abzuschließen!"
      },
      "LEAVE_CONFIRM": {
        "TITLE": "Seite verlassen?",
        "TEXT": "Sind sie sicher, dass Sie die Seite verlassen wollen? Alle Änderungen gehen damit verloren!",
        "ACCEPT": "Seite verlassen"
      },
      "SELECT_VARIANT": {
        "TITLE": "Auftrag abschließen",
        "INFO": "Tippen Sie auf eine Variante um fortzufahren",
        "INVOICE": "Kreditrechnung erstellen",
        "LIEFERSCHEIN": "Lieferschein erstellen"
      },
      "ADD_ITEM": {
        "TITLE": "Artikel hinzufügen",
        "SAVE": "Speichern",
        "ALREADY_ADDED": "Es sind bereits alle Möglichen Artikel im Auftrag enthalten. Bitte passen Sie die Mengen im Auftrag an!",
        "ITEM_NUMBER_PREFIX": "Art.-Nr.:"
      },
      "COMPLETE_TRANSPORT_CONFIRM": {
        "TITLE_SG": "Achtung! 1 offene Station",
        "TITLE_PL": "Achtung! {{count}} offene Stationen",
        "MESSAGE_SG": "Es ist noch 1 Station offen. Sind Sie sicher, dass Sie den Auftrag abschließen wollen?",
        "MESSAGE_PL": "Es sind noch {{count}} Station offen. Sind Sie sicher, dass Sie den Auftrag abschließen wollen?"
      }
    },
    "LIST": {
      "TITLE": "Übersicht",
      "OVERLINE": "Offene Aufträge",
      "NO_DATA": "Es sind zur Zeit keine Aufträge für Sie verfügbar",
      "END_INFO": "Keine weiteren Aufträge",
      "ITEM": {
        "NAME_PREFIX": "Transportauftrag"
      }
    },
    "ORDER_DETAIL": {
      "TITLE_PREFIX": "Transportauftrag",
      "VEHICLE": "Fahrzeug",
      "DELIVERY_DATE": "Lieferdatum",
      "TOTAL_AMOUNT": "Gesamtmenge",
      "SUBMIT": "Transportauftrag abschließen",
      "NO_STATION_NAME": "Kein Name",
      "STATION_PREFIX": "Station",
      "STATION_OVERLINE": "Stationen",
      "BELEGVERMERK_OVERLINE": "Belegvermerk",
      "ITEM_NUMBER_PREFIX": "Art.-Nr.:",
      "AUFTRAG_PREFIX": "Auftrag",
      "CHANGED": "GEÄNDERT",
      "COMPLETED": "ABGESCHLOSSEN"
    },
    "STATION_DETAIL": {
      "TITLE_PREFIX": "Station",
      "ORDER_PREFIX": "Auftrag",
      "CUSTOMER_OVERLINE": "Kunde",
      "MAPS_LINK": "In Maps öffnen",
      "PHONE_PREFIX": "Telefon",
      "POSITIONS_OVERLINE": "Alle Positionen",
      "ADD_ITEM": "Artikel hinzufügen",
      "BELEGVERSAND_OVERLINE": "Belegversand E-Mail",
      "DESCRIPTION_OVERLINE": "Bemerkung",
      "PHOTOS_OVERLINE": "Fotos",
      "SIGNATURE_OVERLINE": "Unterschrift",
      "SUBMIT": "Auftrag abschließen",
      "CLOSE": "Schließen",
      "EXT_LIEF_OVERLINE": "Externe Lieferscheinnummer (Bezugsnummer)",
      "INPUT": {
        "NO_NAME": "Keine Artikelbezeichnung",
        "ITEM_NUMBER_PREFIX": "Art.-Nr.:"
      },
      "ERROR_AMOUNT": "Es muss bei allen Lieferscheinpositionen eine Menge eingegeben werden!",
      "ADDITIONAL_INFO": "Sonstige Informationen",
      "SAVING": "Auftrag wird abgeschlossen..."
    }
  }
}
